import React, { useState } from 'react'
import { Input, Form, stringToSlug, Button } from '@guillotinaweb/react-gmi'
import { setLangs } from '../../consts'
import { useLocation } from 'wouter'
import {
  fixSlugs,
  isUnusualLandingSlug,
  slugifyLandingValue,
} from '../landingSlug'

export function LandingForm({ onSubmit }) {
  const [loading, setLoading] = useState(false)
  const [title, setTitle] = useState(setLangs(''))
  const [slug, setSlug] = useState(setLangs(''))
  const [slugTouched, setSlugTouched] = useState(setLangs(false))
  const inputs = Object.keys(title)
  const [, navigate] = useLocation()

  function onTitle(lang, value) {
    setTitle((current) => ({ ...current, [lang]: value }))
    if (!slugTouched[lang]) {
      setSlug((current) => ({
        ...current,
        [lang]: slugifyLandingValue(value),
      }))
    }
  }

  function onSlug(lang, value) {
    setSlugTouched((current) => ({ ...current, [lang]: true }))
    setSlug((current) => ({
      ...current,
      [lang]: isUnusualLandingSlug(value) ? value : slugifyLandingValue(value),
    }))
  }

  async function submit() {
    setLoading(true)
    try {
      const fixedSlugs = {}
      const unusual = []
      for (const [code, value] of Object.entries(slug || {})) {
        if (!value) continue
        if (isUnusualLandingSlug(value)) {
          fixedSlugs[code] = value
          unusual.push([code, value])
        } else {
          fixedSlugs[code] = fixSlugs({ [code]: value })[code]
        }
      }
      if (
        unusual.length > 0 &&
        !window.confirm(
          `Hay slugs que no tienen el formato aaa-bb-ccc-ddd. ¿Estás seguro de guardarlos así?\n\n${unusual
            .map(([code, value]) => `${code}: ${value}`)
            .join('\n')}`
        )
      ) {
        return
      }
      const id = stringToSlug(fixedSlugs.es || '').replace(/(^-|-$)/g, '')
      if (!id) return

      await onSubmit({
        '@type': 'Landing',
        template: 'landing',
        description: setLangs(''),
        id,
        products: [],
        for_langs: [],
        slug: fixedSlugs,
        title,
      })
      navigate(`/?path=/landings/${id}/`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Form onSubmit={submit}>
      <h1 className="title is-size-4 has-text-primary">Add new Landing</h1>

      {inputs.map((lang) => (
        <div key={lang}>
          <Input
            id={`title-${lang}`}
            required
            placeholder={`Title (${lang.toUpperCase()})`}
            value={title[lang]}
            onChange={(value) => onTitle(lang, value)}
          />
          <Input
            id={`slug-${lang}`}
            required
            placeholder={`Slug (${lang.toUpperCase()})`}
            value={slug[lang]}
            onChange={(value) => onSlug(lang, value)}
          />
        </div>
      ))}

      <div style={{ marginTop: 20 }} className="level level-right">
        <Button className="is-primary" loading={loading}>
          Create
        </Button>
      </div>
    </Form>
  )
}
